// Primary action submenu for the task row context menu.
import { Menu, MenuItem, ListItemText } from '@mui/material';
import { useT } from '@/i18n/useT';

/**
 * @param {{
 *   task: import('@/types').Task,
 *   actions: string[],
 *   open: boolean,
 *   anchorPosition: { mouseX: number, mouseY: number }|null,
 *   onClose: () => void,
 *   onOpenAssign: () => void,
 *   onMoveToTomorrow: () => void,
 *   onMoveToToday: () => void,
 *   onMoveToBacklog: () => void,
 *   onMoveToActive: () => void,
 *   onAddSubtask: () => void,
 *   onDelete: () => void,
 * }} props
 */
export function TaskContextMenuPrimary({
  task,
  actions,
  open,
  anchorPosition,
  onClose,
  onOpenAssign,
  onMoveToTomorrow,
  onMoveToToday,
  onMoveToBacklog,
  onMoveToActive,
  onAddSubtask,
  onDelete,
}) {
  const t = useT();

  return (
    <Menu
      open={open}
      onClose={onClose}
      anchorReference="anchorPosition"
      anchorPosition={
        anchorPosition
          ? { top: anchorPosition.mouseY, left: anchorPosition.mouseX }
          : undefined
      }
      slotProps={{ list: { 'data-testid': 'task-context-menu' } }}
    >
      {actions.includes('assign') ? (
        <MenuItem
          onClick={(e) => {
            e.stopPropagation();
            onOpenAssign();
          }}
          data-testid="context-menu-assign"
        >
          <ListItemText primary={t('contextMenu.assign', 'Waiting for…')} />
        </MenuItem>
      ) : null}
      {actions.includes('moveToTomorrow') && !task.completed ? (
        <MenuItem
          onClick={onMoveToTomorrow}
          data-testid="context-menu-move-tomorrow"
        >
          <ListItemText
            primary={t('contextMenu.moveToTomorrow', 'Move to tomorrow')}
          />
        </MenuItem>
      ) : null}
      {actions.includes('moveToToday') && !task.completed ? (
        <MenuItem onClick={onMoveToToday} data-testid="context-menu-move-today">
          <ListItemText
            primary={t('contextMenu.moveToToday', 'Move to today')}
          />
        </MenuItem>
      ) : null}
      {actions.includes('moveToBacklog') &&
      !task.completed &&
      task.status !== 'Backlog' ? (
        <MenuItem
          onClick={onMoveToBacklog}
          data-testid="context-menu-move-backlog"
        >
          <ListItemText
            primary={t('contextMenu.moveToBacklog', 'Move to backlog')}
          />
        </MenuItem>
      ) : null}
      {actions.includes('moveToActive') &&
      !task.completed &&
      task.status === 'Backlog' ? (
        <MenuItem
          onClick={onMoveToActive}
          data-testid="context-menu-move-active"
        >
          <ListItemText
            primary={t('contextMenu.moveToActive', 'Move to active')}
          />
        </MenuItem>
      ) : null}
      {actions.includes('addSubtask') ? (
        <MenuItem onClick={onAddSubtask} data-testid="context-menu-add-subtask">
          <ListItemText primary={t('contextMenu.addSubtask', 'Add subtask')} />
        </MenuItem>
      ) : null}
      {actions.includes('delete') ? (
        <MenuItem onClick={onDelete} data-testid="context-menu-delete">
          <ListItemText primary={t('contextMenu.delete', 'Delete')} />
        </MenuItem>
      ) : null}
    </Menu>
  );
}
